import { render, staticRenderFns } from "./mucWorkCriteriaList.vue?vue&type=template&id=dfca23a8&scoped=true&"
import script from "./mucWorkCriteriaList.vue?vue&type=script&lang=js&"
export * from "./mucWorkCriteriaList.vue?vue&type=script&lang=js&"
import style0 from "./mucWorkCriteriaList.vue?vue&type=style&index=0&id=dfca23a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfca23a8",
  null
  
)

export default component.exports